
import { Button } from "@/components/ui/button";
import type { OnboardingOption } from "./types";

interface OptionCardProps {
  option: OnboardingOption;
  isSelected: boolean;
  onSelect: (value: string) => void;
  isHovered: boolean;
  onHover: (value: string | null) => void;
  disabled?: boolean;
  disabledReason?: string;
}

export const OptionCard = ({
  option,
  isSelected,
  onSelect,
  isHovered,
  onHover,
  disabled = false,
  disabledReason,
}: OptionCardProps) => {
  const handleClick = () => {
    if (!disabled) {
      onSelect(option.value);
    }
  };

  return (
    <div
      onMouseEnter={() => !disabled && onHover(option.value)}
      onMouseLeave={() => onHover(null)}
    >
      <Button
        type="button"
        variant="outline"
        size="lg"
        className={`relative h-auto p-3 flex flex-col items-center space-y-1 transition-all duration-300 text-left w-full overflow-hidden min-h-[80px] justify-center
          ${disabled 
            ? "opacity-50 cursor-not-allowed bg-muted/30 border-muted text-muted-foreground" 
            : isSelected 
              ? "bg-primary/10 border-primary" 
              : "hover:bg-primary/5"
          }
        `}
        onClick={handleClick}
        disabled={disabled}
      >
        <div className="text-center relative z-10">
          <span className="text-sm font-semibold">
            {option.label}
          </span>
          {option.description && (
            <span className="text-xs text-muted-foreground mt-0.5 block whitespace-normal break-words">
              {option.description}
            </span>
          )}
          {disabled && disabledReason && (
            <span className="text-xs text-muted-foreground mt-1 block font-medium">
              {disabledReason}
            </span>
          )}
        </div>
      </Button>
    </div>
  );
};
